import React from "react";

const ResultContext = React.createContext()

export default ResultContext;